<div *ngIf="data" #chartContainer></div>